const LEGACY_COLORS = {
  GREEN: '#07c98f',
  YELLOW: '#fdc030',
  GRAY_LIGHTER: '#f4f4f4',
  RED: '#ff5151',
  BLUE: '#3894fd',
  BLUE_DARK: '#3991fb',
  PURPLE: '#974fef',
  PURPLE_LIGHTER: '#B244F7',

  GRAY: '#404040',
  GRAY_MEDIUM_DARK: '#757575',
  GRAY_MEDIUM: '#a5a5a5',
  GRAY_LIGHT: '#d9d9d9',
  ALMOST_BLACK: '#282828',
  CONTENT_STUDIO_BRAND: '#8746B8',
  PURPLE_BG_LIGHT: '#F1ECFF',
  PURPLE_DARK: '#423466',
  PURPLE_MEDIUM: '#634E99',
  DARK_GREEN: '#0B4E41',
};

export default LEGACY_COLORS;
